import React from 'react';
import styles from './styles.m.sass';
import 'easymde/dist/easymde.min.css';
import 'emoji-mart/css/emoji-mart.css';
import IconSvg from 'components/IconSvg';
import IconButton from 'components/IconButton';
import AIPrompt from 'assets/icons/ai-prompt.i.svg';
import Close from 'assets/icons/close.i.svg';
var JobTaxAssistantPromptPicker = function JobTaxAssistantPromptPicker(props) {
  var prompts = props.prompts,
    onClose = props.onClose,
    onPromptClick = props.onPromptClick;
  return /*#__PURE__*/React.createElement("div", {
    className: styles.container
  }, /*#__PURE__*/React.createElement(IconButton, {
    className: styles.closeButton,
    onClick: onClose
  }, /*#__PURE__*/React.createElement(IconSvg, {
    size: 24
  }, /*#__PURE__*/React.createElement(Close, {
    color: "var(--grey400)"
  }))), /*#__PURE__*/React.createElement("header", {
    className: styles.header
  }, "Suggested topics for assistance"), /*#__PURE__*/React.createElement("ul", null, prompts.map(function (prompt, index) {
    return /*#__PURE__*/React.createElement("li", {
      key: index,
      className: styles.listItem,
      onClick: function onClick() {
        onPromptClick(prompt);
        onClose();
      }
    }, /*#__PURE__*/React.createElement(IconSvg, {
      size: 16,
      className: styles.listItemIcon
    }, /*#__PURE__*/React.createElement(AIPrompt, null)), /*#__PURE__*/React.createElement("span", null, prompt));
  })));
};
export default JobTaxAssistantPromptPicker;
//# sourceMappingURL=index.js.map
